import React, { CSSProperties } from 'react';
import { Property } from 'csstype';

interface Props {
  align?: Property.TextAlign;
  children: string | React.ReactElement;
  style?: CSSProperties;
}

function Text({
  align = 'left',
  children,
  style = {}
}: Props): React.ReactElement {
  return (
    <p className="c-modal-text" style={{ textAlign: align, ...style }}>
      {children}
    </p>
  );
}

export default Text;
